import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import {
  BalanceCreditApplicationUrlApiResponse,
  BalanceCreditApplicationUrlRawResponse,
} from 'src/types/Balance';

export const getBalanceCreditApplicationUrlEndpoint = (
  onboardingId: string,
  corpId: string
): string => {
  const params = new URLSearchParams({ corpId });

  return `/b2gexternalgateway/balance/buyers/credit-application-url/${encodeURIComponent(
    onboardingId
  )}?${params.toString()}`;
};

export async function fetchBalanceCreditApplicationUrl(
  onboardingId: string,
  corpId: string
): Promise<BalanceCreditApplicationUrlApiResponse> {
  const response: BalanceCreditApplicationUrlRawResponse = await sdk.http.get(
    getBalanceCreditApplicationUrlEndpoint(onboardingId, corpId)
  );
  return camelizeResponseData(response);
}
